import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureModule } from '../sm-base/models/feature.module';
import { MainAppService } from '../app-template/services/main-app.service';
import { FeatureModuleService } from '../sm-base/services/feature-module.service';
import { AppTab } from '../app-template/models/app-tab.model';
import { Route } from '@angular/router';
import { InvoiceGeneratorRoutingModule } from './invoice-generator-routing.module';
import { EditInvoiceComponent } from './components/edit-invoice/edit-invoice.component';
import { InvoiceGeneratorMainComponent } from './components/invoice-generator-main/invoice-generator-main.component';
import { SmBaseModule } from "../sm-base/sm-base.module";
import { AppTemplateModule } from '../app-template/app-template.module';
import { PrimeModule } from '../prime/prime.module';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';



@NgModule({
  declarations: [
    EditInvoiceComponent,
    InvoiceGeneratorMainComponent
  ],
  imports: [
    AppTemplateModule,
    CommonModule,
    PrimeModule,
    SmBaseModule,
    PdfJsViewerModule
  ]
})
export class InvoiceGeneratorModule implements FeatureModule {

    app = inject(MainAppService);
    featureModuleService = inject(FeatureModuleService);

    constructor() {
        this.featureModuleService.register(this);
    }

    async beforeAppStart(): Promise<void> {
    }

    registerSidebar(model: AppTab[]): void {
        /*model.push(new AppTab("workflows", "Workflows", "", 100, [
            Utils.fromPlain(AppMenuItem, { sort: 170, label: "Workflows", icon: "", routerLink: ["/enaio-workflows", "home"] })
        ]));

        EnaioDocumentsModule.mainBreadcrumb =  { label: "Personalakte", routerLink: ["/enaio-documents", "home"] };
   */ }

    
    async updateSidebarVisibility(_: AppTab[]): Promise<void> {
    }

    getMainRoute(): Route {
        return this.featureModuleService.createModuleRoute("invoice-generator", () => InvoiceGeneratorRoutingModule);
    }
}
